<template>
  <div class="tw-space-y-2">
    <Text v-if="mode === 'default'">
      {{ t('sidebar_status.wiring') }}
      <Text tag="span" class="tw-font-black">{{ t('sidebar_status.wiring_default') }}</Text>
    </Text>

    <div v-else class="tw-space-y-2">
      <Text class="tw-font-black">{{ t('sidebar_status.wiring_heading') }}</Text>

      <ul class="tw-ml-5 tw-list-disc tw-space-y-1">
        <li v-for="row in rows" :key="row.key">
          <Text tag="span" v-tooltip="tooltip(row)" :class="row.changed ? 'tw-font-black' : ''">
            {{ row.label }}: {{ row.value }}
          </Text>

          <Text tag="span" v-if="row.statusLabel" size="small" :class="statusClass(row)">
            {{ statusText(row) }}
          </Text>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

import { Text } from '@slideslive/fuse-kit/vue';

import { WIRING_STATUS } from '@/stores/state';

defineProps({
  mode: { type: String, required: true },
  rows: { type: Array, required: true },
});

const { t } = useI18n();

function tooltip(row) {
  return {
    disabled: !row.description,
    html: true,
    content: row.description,
  };
}

function statusClass(row) {
  if (row.statusLabel === WIRING_STATUS.TO_CHANGE) return 'tw-text-state-warn tw-font-black tw-ml-1';
  if (row.statusLabel === WIRING_STATUS.CHANGED) return 'tw-text-state-succ tw-font-black tw-ml-1';
  return '';
}

function statusText(row) {
  if (row.statusLabel === WIRING_STATUS.TO_CHANGE) return t('sidebar_status.status_to_change');
  if (row.statusLabel === WIRING_STATUS.CHANGED) return t('sidebar_status.changed');
  return '';
}
</script>
